'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionMixin = void 0;
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var magic_sdk_1 = require("@gig/magic-sdk");
var util_1 = require("../util");
/**
 * Adds information about session and logged in user (if any)
 */
var SessionMixin = /** @class */ (function (_super) {
    tslib_1.__extends(SessionMixin, _super);
    function SessionMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isLoggedIn = false;
        _this.user = null;
        return _this;
    }
    SessionMixin.prototype.created = function () {
        var _this = this;
        magic_sdk_1.magic.events.userUpdated(function () {
            _this.user = tslib_1.__assign({}, magic_sdk_1.magic.session.getUser());
        });
    };
    SessionMixin.prototype.onSessionChange = function (isLoggedIn) {
        this.isLoggedIn = isLoggedIn;
        this.user = isLoggedIn ? magic_sdk_1.magic.session.getUser() : null;
    };
    tslib_1.__decorate([
        util_1.SessionChange({ immediate: true })
    ], SessionMixin.prototype, "onSessionChange", null);
    SessionMixin = tslib_1.__decorate([
        vue_property_decorator_1.Component
    ], SessionMixin);
    return SessionMixin;
}(vue_property_decorator_1.Vue));
exports.SessionMixin = SessionMixin;
